import {useEffect, useReducer, useRef} from "react";
import {initialState, reducer} from "./state";
import {ActionTypeReducer} from "helpers/types";
import axios from "axios";
import {convertMasksFormat, validatorEngine} from "../../../../../helpers/functions";
import {UserModelGet, UserModelInsert} from "models/user_model";
import {EmpresaModel} from "models/empresa";
import {
    AccessRule,
    mergePermissionStringToObject,
    permissionObjectToString,
} from "../../../../../helpers/permission";

type changeInputTypeUser = ActionTypeReducer<typeof initialState.user>
type changeInputTypeContact = ActionTypeReducer<typeof initialState.user.UsuarioContato[0]>
type changeInputTypeAddress = ActionTypeReducer<typeof initialState.user.UsuarioEndereco[0]>

export const useNewUser = () => {

    const [state, dispatch] = useReducer(reducer, initialState);

    const cancelRef = useRef();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        dispatch({type: "setLoading", payload: true});

        try {
            const [users, companies] = await Promise.all([loadUsers(), loadCompanies()]);

            dispatch({type: "setList", payload: users.data});
            dispatch({type: "setCompanyList", payload: companies.data});
        } catch (e) {
            console.error("useEffect.loadData/loadCompany ", e);
            showError("Erro", "Erro ao carregar dados")
        } finally {
            dispatch({type: "setLoading", payload: false});
        }
    }

    const getLoggedUser = () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        dispatch({type: "setLoggedUser", payload: userData});

        return userData as UserModelGet;
    }

    const loadUsers = () => {
        const user = state.loggedUser ?? getLoggedUser();

        return axios.get<UserModelGet[]>(
            process.env.REACT_APP_API_URL + "/user/list/" + user.idEmpresa
        );
    }

    const loadCompanies = async () => {
        return axios.get<EmpresaModel[]>(
            process.env.REACT_APP_API_URL + "/empresa"
        );
    }

    const validateUserFields = () => {
        const {user} = state;
        const validations: validatorEngine.type<typeof initialState.userFormFieldsError> = {
            nome: {
                test: () => validatorEngine.testString("minLength", user.nome, 8),
                errorMessage: "O nome precisa ter mais de 8 caracteres"
            },
            cpf: {
                test: () => validatorEngine.testString("cpf", user.cpf),
                errorMessage: "O CPF precisa ser válido"
            },
            // rg: {
            //     test: () => validatorEngine.testString("rg", user.rg),
            //     errorMessage: "O RG precisa ser válido"
            // },
            // nascimento: {
            //     test: () => validatorEngine.testString("required", user.nascimento),
            //     errorMessage: "A data de nascimento precisa ser preenchida"
            // },
            // "UsuarioContato.cargo": {
            //     test: () => validatorEngine.testString("required", user.UsuarioContato[0].cargo),
            //     errorMessage: "O cargo precisa ser preenchido"
            // },
            // dataAdmissao: {
            //     test: () => validatorEngine.testString("required", user.dataAdmissao),
            //     errorMessage: "A data de admissão precisa ser preenchida"
            // },
            // pispasep: {
            //     test: () => validatorEngine.testString("required", user.pispasep),
            //     errorMessage: "O PIS/PASEP precisa ser preenchido"
            // },
            // ctps: {
            //     test: () => validatorEngine.testString("ctps", user.ctps),
            //     errorMessage: "O CTPS precisa ser válido"
            // },
            // codigo: {
            //     test: () => validatorEngine.testString("required", user.codigo),
            //     errorMessage: "O código precisa ser preenchido"
            // },
            // salario: {
            //     test: () => validatorEngine.testString("required", user.salario),
            //     errorMessage: "O salário precisa ser preenchido"
            // },
            email: {
                test: () => validatorEngine.testString("email", user.email),
                errorMessage: "O email precisa ser válido"
            },
            senha: {
                test: () => validatorEngine.testString("password", user.senha),
                errorMessage: "A senha precisa ter ao menos 8 caracteres, uma letra maiúscula e um número"
            },
            // idEmpresa: {
            //     test: () => validatorEngine.testString("required", user.idEmpresa),
            //     errorMessage: "Selecione uma empresa"
            // },
            // "UsuarioContato.nome": {
            //     test: () => validatorEngine.testString("required", user.UsuarioContato[0].nome),
            //     errorMessage: "O nome do contato precisa ser preenchido"
            // },
            "UsuarioContato.telefone": {
                test: () => validatorEngine.testString("phone", user.UsuarioContato[0].telefone),
                errorMessage: "O telefone do contato precisa ser válido"
            },
            // "UsuarioContato.email": {
            //     test: () => validatorEngine.testString("email", user.UsuarioContato[0].email),
            //     errorMessage: "O email do contato precisa ser válido"
            // },
            // "UsuarioEndereco.cep": {
            //     test: () => validatorEngine.testString("cep", user.UsuarioEndereco[0].cep),
            //     errorMessage: "O CEP precisa ser válido"
            // },
            // "UsuarioEndereco.estado": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].estado),
            //     errorMessage: "O estado precisa ser preenchido"
            // },
            // "UsuarioEndereco.cidade": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].cidade),
            //     errorMessage: "A cidade precisa ser preenchida"
            // },
            // "UsuarioEndereco.bairro": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].bairro),
            //     errorMessage: "O bairro precisa ser preenchido"
            // },
            // "UsuarioEndereco.local": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].local),
            //     errorMessage: "O local precisa ser preenchido"
            // },
            // "UsuarioEndereco.numero": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].numero),
            //     errorMessage: "O número precisa ser preenchido"
            // },
            // "UsuarioEndereco.complemento": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].complemento),
            //     errorMessage: "O complemento precisa ser preenchido"
            // },
            // "UsuarioEndereco.observacao": {
            //     test: () => validatorEngine.testString("required", user.UsuarioEndereco[0].observacao),
            //     errorMessage: "A observação precisa ser preenchida"
            // },
        };

        const {isValid, errors} = validatorEngine.build(validations);

        dispatch({
            type: "setUserFormFieldsError",
            payload: {...state.userFormFieldsError, ...errors}
        });

        return isValid;
    };

    const displayInputError = (type: keyof typeof initialState.userFormFieldsError) => {
        const error = state.userFormFieldsError[type];

        return ({
            error: !!error,
            errorMessage: error
        })
    }

    const addRegister = () => {
        const {id, Permissao, UsuarioContato, UsuarioEndereco, ...payload} = state.user;

        const user: UserModelInsert = {
            ...payload,
            cpf: convertMasksFormat("cpf", payload.cpf),
            rg: convertMasksFormat("rg", payload.rg),
            ctps: convertMasksFormat("ctps", payload.ctps),
            pispasep: convertMasksFormat("pispasep", payload.pispasep),
            salario: Number(payload.salario),
            contato: [
                {
                    nome: UsuarioContato[0].nome,
                    cargo: UsuarioContato[0].cargo,
                    email: UsuarioContato[0].email,
                    telefone: convertMasksFormat("phone", UsuarioContato[0].telefone),
                    principal: true
                }
            ],
            endereco: [
                {
                    cep: convertMasksFormat("cep", UsuarioEndereco[0].cep),
                    estado: UsuarioEndereco[0].estado,
                    cidade: UsuarioEndereco[0].cidade,
                    bairro: UsuarioEndereco[0].bairro,
                    local: UsuarioEndereco[0].local,
                    numero: UsuarioEndereco[0].numero,
                    complemento: UsuarioEndereco[0].complemento,
                    observacao: UsuarioEndereco[0].observacao,
                    principal: true
                }
            ],
            permissoes: permissionObjectToString(state.permission)
        }

        return axios.post<string>(
            process.env.REACT_APP_API_URL + "/user/",
            user
        );
    }

    const deleteRegister = (user: UserModelGet) => {
        return axios.delete(
            process.env.REACT_APP_API_URL + "/user/" + user.id
        );
    }

    const patchRegister = () => {
        const { Permissao, UsuarioContato, UsuarioEndereco,  ...payload } = {...state.user};

        const user: UserModelInsert = {
            ...payload,
            cpf: convertMasksFormat("cpf", payload.cpf),
            rg: convertMasksFormat("rg", payload.rg),
            ctps: convertMasksFormat("ctps", payload.ctps),
            pispasep: convertMasksFormat("pispasep", payload.pispasep),
            salario: Number(payload.salario),
            contato: [
                {
                    id: UsuarioContato[0].id,
                    idUsuario: payload.id,
                    nome: UsuarioContato[0].nome,
                    cargo: UsuarioContato[0].cargo,
                    email: UsuarioContato[0].email,
                    telefone: convertMasksFormat("phone", UsuarioContato[0].telefone),
                    principal: true
                }
            ],
            endereco: [
                {
                    id: UsuarioEndereco[0].id,
                    idUsuario: payload.id,
                    cep: convertMasksFormat("cep", UsuarioEndereco[0].cep),
                    estado: UsuarioEndereco[0].estado,
                    cidade: UsuarioEndereco[0].cidade,
                    bairro: UsuarioEndereco[0].bairro,
                    local: UsuarioEndereco[0].local,
                    numero: UsuarioEndereco[0].numero,
                    complemento: UsuarioEndereco[0].complemento,
                    observacao: UsuarioEndereco[0].observacao,
                    principal: true
                }
            ],
            permissoes: permissionObjectToString(state.permission)
        }

        return axios.patch(
            process.env.REACT_APP_API_URL + "/user/" + payload.id,
            user
        );
    }

    const saveUser = async () => {
        if (!validateUserFields()) return;

        dispatch({type: "setLoading", payload: true});

        try {
            if (state.user.id) {
                await patchRegister();
            } else {
                await addRegister();
            }

            showModal(false);
            await loadData();
        } catch (e) {
            console.error("useNewUser.saveUser ", e);
            showError("Erro", "Erro ao salvar usuário")
        } finally {
            dispatch({type: "setLoading", payload: false});
        }
    }

    const deleteUser = async (user: UserModelGet) => {
        dispatch({type: "setLoading", payload: true});

        try {
            await deleteRegister(user);

            await loadData();
        } catch (e) {
            console.error("useNewUser.deleteUser ", e);
            showError("Erro", "Erro ao deletar usuário")
        } finally {
            dispatch({type: "setLoading", payload: false});
        }
    }

    const editUser = (user: UserModelGet) => {
        const mergedUser = mergeUserData(state.user, user);
        dispatch({ type: "setUser", payload: mergedUser });

        const userPermission = user.Permissao.length > 0 ? user.Permissao[0].item.split(",") : [];
        const merge = mergePermissionStringToObject(userPermission, state.permission);

        dispatch({type: "setPermission", payload: merge});
        showModal(true);
    }

    const mergeUserData = (defaultData: typeof state.user, apiData: Partial<UserModelGet>) => {
        return {
            ...defaultData,
            ...apiData,
            Permissao: apiData.Permissao && apiData.Permissao.length > 0 ? apiData.Permissao : defaultData.Permissao,
            UsuarioContato: apiData.UsuarioContato && apiData.UsuarioContato.length > 0 ? apiData.UsuarioContato : defaultData.UsuarioContato,
            UsuarioEndereco: apiData.UsuarioEndereco && apiData.UsuarioEndereco.length > 0 ? apiData.UsuarioEndereco : defaultData.UsuarioEndereco,
        };
    };

    const add = () => {
        showModal(true);
    };

    const changeInput = ({type, payload}: changeInputTypeUser) => {
        const user = {...state.user, [type]: payload};
        dispatch({type: "setUser", payload: user});
    }

    const changeContactInput = ({type, payload}: changeInputTypeContact) => {
        const contact = {...state.user.UsuarioContato[0], [type]: payload};

        dispatch({type: "setUser", payload: {...state.user, UsuarioContato: [contact]}});
    }

    const changeAddressInput = ({type, payload}: changeInputTypeAddress) => {
        const address = {...state.user.UsuarioEndereco[0], [type]: payload};

        dispatch({type: "setUser", payload: {...state.user, UsuarioEndereco: [address]}});
    }

    const changeInputPermission = (key: string, rule: keyof typeof AccessRule, payload: boolean) => {
        // @ts-ignore
        const permission = {...state.permission, [key]: {...state.permission[key], rules: {...state.permission[key].rules, [rule]: payload}}};

        dispatch({type: "setPermission", payload: permission});
    }

    const showModal = (show: boolean) => {
        dispatch({type: "setShow", payload: show});
        dispatch({type: "setError", payload: false});
        if (!show) {
            dispatch({type: "setUser", payload: initialState.user});
            dispatch({type: "setUserFormFieldsError", payload: initialState.userFormFieldsError});
        }
    };

    const closeDelete = () => {
        dispatch({type: "setShowDelete", payload: false});
    };

    const closeError = () => {
        dispatch({type: "setError", payload: false});
    };

    const showError = (title: string, msg: string) => {
        dispatch({type: "setError", payload: true});
        dispatch({type: "setErrorTitle", payload: title});
        dispatch({type: "setErrorMsg", payload: msg});
    };


    return {
        state,
        cancelRef,
        add,
        closeDelete,
        closeError,
        showError,
        showModal,
        changeInput,
        changeContactInput,
        changeAddressInput,
        changeInputPermission,
        saveUser,
        deleteUser,
        editUser,
        displayInputError,
    };
};

export namespace useNewUser {
    export type type = ReturnType<typeof useNewUser>;
}
